exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".history-log-content{margin-top:16px !important;padding-left:150px}.history-log-content__time{position:absolute;left:-150px;top:0}.history-log-content__container{display:flex;width:100%;margin-right:50px}.history-log-content__name{font-weight:700;color:#000;font-size:12px}.history-log-content__role{font-weight:400;color:#767676;font-size:12px}.history-log-content__avatar{position:absolute;left:-7px;top:-5px}.history-log-content__divider{margin-top:16px;border-top:1px dashed #DCDCDC;margin-left:-22px}\n", ""]);

// exports
